/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Line, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function BellSimpleSlash(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Line
        x1={96}
        y1={227.97925}
        x2={160}
        y2={227.97925}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={48}
        y1={40}
        x2={208}
        y2={216}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M182.52658,187.97925H48.98365A7.99908,7.99908,0,0,1,42.103,175.93566c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-4A71.80588,71.80588,0,0,1,68.93752,63.03149"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M99.95187,37.68155a71.42431,71.42431,0,0,1,28.59653-5.70028c39.58967.29432,71.25651,33.20133,71.25651,72.90185v3.09613c0,18.98255,2.10491,33.7424,5.0661,45.11452"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default BellSimpleSlash;
